'use client'

import { useHandleHashError } from '@/hooks/auth/useHashError'

export default function UrlChecker() {
  useHandleHashError()

  return null
}
